<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-dialog v-if="isView" v-model="isView" persistent width="800" >
        <v-card class="mt-3 pa-1">
            <Title title="圃場の編集">
                <v-spacer />
                <TitleButton
                    icon="mdi-floppy"
                    name="保存"
                    @click="onClickSave()" />
                <TitleButton
                    icon="mdi-close-circle"
                    name="閉じる"
                    @click="isView = false" />
            </Title>
            <v-card-text class="pa-0">
                <v-form ref="form">
                    <v-tabs
                        v-model="currentTabIndex" >
                        <v-tab v-for="item in tabItems" :key="item.tab">
                            <v-chip v-if="currentTabIndex == item.index" color="green lighten-4" label>
                                <v-icon>{{item.icon}}</v-icon>
                                {{item.tab}}                    
                            </v-chip>
                            <span v-else>
                                <v-icon>{{item.icon}}</v-icon>
                                {{item.tab}}
                            </span>
                        </v-tab>
                        <v-tabs-items v-model="currentTabIndex" :touchless="true">
                            <v-tab-item>
                                <v-container fluid class="pb-0">
                                    <v-row>
                                        <v-col cols="12" xs="12" sm="4" md="4" lg="3" xl="3" class="pt-0">
                                            <v-card :max-width=180 outlined v-if="editImage != null">
                                                <v-layout justify-center style="margin-top:10px">
                                                    <v-img v-if="editImage.state == 2 || (editImage.url == '' && editImage.image == '')" src="@/assets/no_avater_image.png" :max-width=150 :max-height=150 contain alt="No image" />
                                                    <v-img v-if="editImage.state != 2 && editImage.url != '' && editImage.image == ''" :src="editImage.url" :max-width=150 :max-height=150 contain />
                                                    <v-img v-if="editImage.state != 2 && editImage.image != ''" :src="editImage.image" :max-width=150 :max-height=150 contain />
                                                </v-layout>
                                                <v-card-actions>
                                                    <v-btn v-if="editImage.state == 1 || editImage.url != ''" icon color="primary" @click="onClickDeleteImage" ><v-icon large>mdi-delete</v-icon></v-btn>
                                                    <v-spacer />
                                                    <ImageImporter @onImportedImage="onImportedImage" />
                                                </v-card-actions>
                                            </v-card>
                                        </v-col>
                                        <v-col class="pa-0">
                                            <v-container fluid class="pa-0">
                                                <v-row dense>
                                                    <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                                        <v-text-field 
                                                            v-model="editItems.name" 
                                                            clearable 
                                                            label="圃場名" 
                                                            outlined 
                                                            type="text" 
                                                            counter="20"
                                                            :rules="[validatorNameLength]"
                                                            dense />
                                                    </v-col>
                                                    <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                                        <v-select 
                                                            dense 
                                                            v-if="groups.length > 0" 
                                                            v-model="editItems.group" 
                                                            label="グループ" 
                                                            outlined 
                                                            :items="groups" 
                                                            item-text="name" 
                                                            item-value="placeGroupID" 
                                                            clearable/>
                                                    </v-col>
                                                </v-row>
                                                <v-row dense>
                                                    <v-col v-if="cultivationTypes.length > 0" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                        <v-select
                                                            dense
                                                            v-model="editItems.cultivationType" 
                                                            label="栽培区分" 
                                                            outlined 
                                                            :items="cultivationTypes" 
                                                            item-text="name" 
                                                            item-value="type" 
                                                            clearable />
                                                    </v-col>
                                                    <v-col v-if="cultivationTypes == null || cultivationTypes.length == 0 || editItems.cultivationType == null || editItems.cultivationType.length == 0" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                                        <v-text-field                                     
                                                            v-model="editItems.cultivationTypeName" 
                                                            clearable 
                                                            label="新しい栽培区分名称" 
                                                            outlined
                                                            type="text"
                                                            dense />
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-col>
                                    </v-row>
                                    <v-row dense>
                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                            <TextFieldEx 
                                                v-model="editItems.details.area" 
                                                clearable
                                                prepend-icon="mdi-texture-box"
                                                suffix="ha"
                                                label="面積" 
                                                outlined 
                                                type="text" 
                                                dense />
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                            <VarietySelector v-model="editItems.details.variety" :crops="crops" />
                                        </v-col>
                                    </v-row>
                                    <v-row dense>
                                        <v-col>
                                            <v-textarea
                                                v-model="editItems.memo"
                                                label="メモ"
                                                rows="2"
                                                outlined
                                                clearable
                                                hide-details
                                                auto-grow>
                                            </v-textarea>
                                        </v-col>
                                    </v-row>
                                    <v-row dense>
                                        <v-expansion-panels class="mb-1">
                                            <v-expansion-panel>
                                                <v-expansion-panel-header>住所</v-expansion-panel-header>
                                                <v-expansion-panel-content>
                                                    <Address v-model="editItems.address" />
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-row>
                                </v-container>
                            </v-tab-item>
                            <v-tab-item>
                                <v-container fluid>
                                    <v-row dense class="mb-2">
                                        <v-col cols="12">
                                            <v-switch label="農薬管理を行う" v-model="editItems.managementAgrichemical.enabled" hide-details class="mb-2" />
                                        </v-col>
                                        <template v-if="editItems.managementAgrichemical.enabled">
                                            <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4" >
                                                <v-select
                                                    dense
                                                    v-model="editItems.managementAgrichemical.target" 
                                                    label="管理農薬" 
                                                    outlined 
                                                    hide-details
                                                    :items="agrichemicals" 
                                                    item-text="body.targetName" 
                                                    item-value="body.target"
                                                    :rules="[validatorRequire]" />
                                            </v-col>
                                            <v-col cols="12" xs="6" sm="3" md="3" lg="3" xl="3" >
                                                <v-select
                                                    dense
                                                    v-model="editItems.managementAgrichemical.startDate.month" 
                                                    label="回数起点(月)" 
                                                    outlined 
                                                    hide-details
                                                    suffix="月"
                                                    :items="agrichemicalStartDateMonths" 
                                                    item-text="targetName" 
                                                    item-value="target"
                                                    @change="onChangedAgrichemicalStartMonth" />
                                            </v-col>
                                            <v-col cols="12" xs="6" sm="3" md="3" lg="3" xl="3" >
                                                <v-select
                                                    dense
                                                    v-model="editItems.managementAgrichemical.startDate.day" 
                                                    label="回数起点(日)" 
                                                    outlined 
                                                    hide-details
                                                    suffix="日"
                                                    :items="agrichemicalStartDateDays" 
                                                    item-text="targetName" 
                                                    item-value="target" />
                                            </v-col>
                                        </template>
                                    </v-row>
                                </v-container>
                            </v-tab-item>
                            <v-tab-item>
                                <v-container fluid>
                                    <v-row dense class="mb-2">
                                        <v-col>
                                            <span>
                                                グループユーザーが、この場所に行える操作
                                            </span>
                                            <v-card outlined class="mt-1">
                                                <v-card-text class="pa-1">
                                                    <div>
                                                        <v-chip 
                                                            v-for="authority in editItems.groupUserAuthorities" 
                                                            :key="authority.authority.key" 
                                                            class="ma-1" 
                                                            :color="authority.enable ? 'primary' : ''"
                                                            @click="authority.enable = !authority.enable">
                                                            {{authority.authority.text}}
                                                        </v-chip>
                                                    </div>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <table>
                                                <tr>
                                                    <td style="width:100%">グループユーザー毎の、この場所に行える操作</td>
                                                    <td>
                                                        <v-btn color="primary" text @click="onClickUsersAuthorityListOrder">
                                                            <template v-if="usersAuthorityListOrder == 'user'"><v-icon>mdi-group</v-icon>グループ毎の表示に切替</template>
                                                            <template v-if="usersAuthorityListOrder == 'group'"><v-icon>mdi-account</v-icon>ユーザー毎の表示に切替</template>
                                                        </v-btn>
                                                    </td>
                                                </tr>
                                            </table>
                                            <v-card outlined class="pa-2">
                                                <v-simple-table fixed-header height="400">
                                                    <thead>
                                                        <tr>
                                                            <th class="text-center">
                                                                ユーザー<br/>(グループ)
                                                            </th>
                                                            <th class="text-center">圃場設定</th>
                                                            <th class="text-center">圃場参照</th>
                                                            <th class="text-center">作業<br/>参照</th>
                                                            <th class="text-center">作業<br/>記録</th>
                                                            <th class="text-center">環境<br/>参照</th>
                                                            <th class="text-center">環境<br/>記録</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-for="(rowData, index) in usersAuthorityList" >
                                                            <v-menu offset-y absolute close-on-content-click :key="index">
                                                                <template v-slot:activator="{ on }">
                                                                    <tr v-on="on">
                                                                        <td style="width:100%" class="pa-2">
                                                                            <span class="font-weight-bold">{{rowData.userInfo.userName}}</span><br/>
                                                                            <span style="font-size:x-small">({{rowData.group.groupName}})</span>
                                                                        </td>
                                                                        <td class="text-center" v-for="authority in authorities" :key="authority">
                                                                            <v-btn icon color="primary" @click.stop="onClickGroupUserAuthority(rowData, authority)" :disabled="!enableGroupUserAuthority(rowData, authority)">
                                                                                <v-icon>{{groupUserAuthorityIcon(rowData, authority)}}</v-icon>
                                                                            </v-btn>
                                                                        </td>
                                                                    </tr>
                                                                </template>
                                                                <v-list dense>
                                                                    <v-list-item @click="onSelectedCopyGroupUserSetting(rowData)">
                                                                        <v-list-item-icon><v-icon>mdi-content-copy</v-icon></v-list-item-icon>
                                                                        <v-list-item-content>このユーザーの設定を他の全員にコピー</v-list-item-content>
                                                                    </v-list-item>
                                                                </v-list>
                                                            </v-menu>
                                                        </template>
                                                    </tbody>
                                                </v-simple-table>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-tab-item>
                            <v-tab-item>
                                <v-container>
                                    <v-row dense>
                                        <span class="mt-1 ml-1">この場所にカメラが設置されている時、ストリーミングのURLを設定して下さい。</span>
                                        <v-container fluid>
                                            <v-row dense>
                                                <v-col>
                                                    <v-select dense v-model="editItems.selectedStreamingURL" label="カメラURL" outlined :items="editItems.streamingURLs" item-text="url" @change="onSelectedURL" return-object hint="カメラのストリーミングURLを設定します。" persistent-hint/>
                                                </v-col>
                                            </v-row>
                                            <v-row dense align="baseline" v-if="editItems.selectedStreamingURL != null">
                                                <v-col>
                                                    <v-text-field 
                                                        v-model="editItems.streamingURL" 
                                                        clearable 
                                                        label="URL" 
                                                        outlined 
                                                        type="text" />
                                                </v-col>
                                                <v-col>
                                                    <v-select v-model="editItems.streamingType" :items="streamTypes" item-text="name" item-value="type" />
                                                </v-col>
                                                <v-col>
                                                    <v-btn v-if="editItems.selectedStreamingURL.isNewData == true" color="primary" class="mr-1" @click="onClickAddStreamingURL">追加</v-btn>
                                                    <v-btn v-if="editItems.selectedStreamingURL.isNewData == false" color="primary" class="mr-1" @click="onClickChangeStreamingURL">変更</v-btn>
                                                    <v-btn v-if="editItems.selectedStreamingURL.isNewData == false" color="primary" class="mr-1" @click="onClickDeleteStreamingURL">削除</v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-row>
                                </v-container>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-tabs>
                </v-form>
            </v-card-text>
        </v-card>
        <Confirm ref="confirm" />
    </v-dialog>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import fb from '@/firebase/firebase.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import Confirm from '@/components/tools/ConfirmDialog';
    import Axios from "axios"
    import ImageImporter from '@/components/tools/ImageImporter';
    import TextFieldEx from '@/components/tools/SoftwareNumKeyboard'
    import VarietySelector from '@/components/seedling/items/SelectorVariety';
    import Address from '@/components/tools/AddressSetter';
    export default {
        props: {
            places: {
                type: Array,
                default: []
            },
            groups: {
                type: Array,
                default: []
            },
            cultivationTypes: {
                type: Array,
                default: []
            },
            crops: {
                type: Array,
                default: []
            }
        },
        components: {
            Title,
            TitleButton,
            ImageImporter,
            Confirm,
            TextFieldEx,
            VarietySelector,
            Address,
        },
        data: function () {
            return {
                maskPostal: "###-####",
                isView: false,
                editItems: {
                    name: "",
                    group: null,
                    streamingURLs: [],
                    selectedStreamingURL: null,     // 選択されたURL
                    streamingURL: "",               // 入力されたURL
                    streamingType: 1,               // 選択されたストリーミング種類
                    address: {
                        postalCode: "",
                        pref: "",
                        city: "",
                        address1: "",
                        address2: "",
                        areaID: ""
                    },
                    cultivationType: null,
                    cultivationTypeName: null,
                    details: {
                        area: 0,    // 面積
                        variety: null
                    },
                    groupUserAuthorities: [],
                    managementAgrichemical: {
                        enabled: false,
                        target: null,
                        startDate: {
                            month: 1,
                            day: 1
                        }
                    },
                    memo: null
                },
                editImage: {
                    url: "",
                    image: "",
                    capturedDate: "",
                    state: 0    // 0:未変更,1:変更,2:削除
                },
                targetPlace: null,
                streamTypes: [
                    {
                        type:1,
                        name:"type-A"
                    },
                    {
                        type:2,
                        name:"type-B"
                    },
                    {
                        type:3,
                        name:"type-C"
                    },
                ],
                agrichemicalStartDateMonths: [],
                agrichemicalStartDateDays: [],
                /** 選択されているタブのインデックス */
                currentTabIndex: 0,
                /** タブの項目 */
                tabItems: [
                    {tab:"圃場情報", index:0, icon:"mdi-home"},
                    {tab:"農薬管理", index:1, icon:"mdi-pill"},
                    {tab:"参照権限", index:2, icon:"mdi-shield-check"},
                    {tab:"ストリーミング", index:3, icon:"mdi-camera-enhance"},
                ],
                /** グループ別ユーザー別権限リスト */
                usersAuthorityList: null,
                /** グループ別ユーザー別権限リストの並び(group, user) */
                usersAuthorityListOrder: "group",
                /** 権限 */
                authorities: [
                    "place", "browse", "work", "work.record", "environment", "environment.record"
                ],
                /** ルール */
                validatorRequire: value => !!value || '必須入力です。',
                validatorNameLength: value => value.length <= 20 || '20文字以内で入力して下さい。',
                validatorAddressLength: value => value.length <= 30 || '30文字以内で入力して下さい。',
            }
        },
        computed: {
            /**
             * ログイン中のユーザーのUID
             */
            loggedInUserUID: function () {
                return this.$store.getters["loggedInUserUID"]
            },
            /** 場所毎のグループユーザーに対する権限 */
            placeGroupUserAuthorities: function () {
                return this.$store.getters["managementItems/placeGroupUserAuthorities"]
            },
            /** システムに登録されている全農薬基礎データ */
            agrichemicals: function () {
                return this.$store.getters["managementItems/agrichemicals"]
            },
            /**
             * グループ別ユーザー毎の権限に表示するアイコン(チェック有り,無し)
             */
            groupUserAuthorityIcon: function () {
                return function (rowData, authority) {
                    if (authority == "place") {
                        if (rowData.authorities == null || rowData.authorities.findIndex((v)=>v == authority) >= 0) {
                            return "mdi-check-circle-outline"
                        }
                        return "mdi-circle-outline"
                    } else if (rowData.authorities != null && rowData.authorities.findIndex((v)=>v == authority) >= 0) {
                        return "mdi-check-circle-outline"
                    }
                    return "mdi-circle-outline"
                }
            },
            /**
             * グループ別ユーザー毎の権限の有効(True)/無効(False)を返す
             */
            enableGroupUserAuthority: function () {
                return function (rowData, authority) {
                    if (authority == "place") {
                        // 権限=圃場設定は、常に有効
                        return true
                    }
                    if (rowData.authorities == null || rowData.authorities.findIndex((v)=>v == "place") >= 0) {
                        // 権限未設定もしくは権限に圃場設定が含まれている時は無効
                        return false
                    }
                    if (authority == "browse") {
                        // 権限=圃場参照は、有効
                        return true
                    }
                    if (authority == "work" && rowData.authorities.findIndex((v)=>v == "browse") >= 0) {
                        // 権限=作業参照は、圃場参照権限が含まれていれば有効
                        return true
                    }
                    if (authority == "work.record" && rowData.authorities.findIndex((v)=>v == "browse") >= 0 && rowData.authorities.findIndex((v)=>v == "work") >= 0) {
                        // 権限=作業記録は、圃場参照権限と作業参照が含まれていれば有効
                        return true
                    }
                    if (authority == "environment" && rowData.authorities.findIndex((v)=>v == "browse") >= 0) {
                        // 権限=環境参照は、圃場参照権限が含まれていれば有効
                        return true
                    }
                    if (authority == "environment.record" && rowData.authorities.findIndex((v)=>v == "browse") >= 0 && rowData.authorities.findIndex((v)=>v == "environment") >= 0) {
                        // 権限=作業記録は、圃場参照権限と環境参照が含まれていれば有効
                        return true
                    }
                    return false
                }
            }
        },
        created: function () {
            this.agrichemicalStartDateMonths = []
            for (var month=1; month<=12; month++) {
                this.agrichemicalStartDateMonths.push(month)
            }
            this.refreshAgrichemicalDays(1)
        },
        methods: {
            /**
             * 権限リストの並び順のボタン押下時
             */
            onClickUsersAuthorityListOrder: function () {
                switch (this.usersAuthorityListOrder) {
                    case "group":
                        this.sortUsersAuthorityList("user")
                        break
                    case "user":
                        this.sortUsersAuthorityList("group")
                        break
                }
            },
            /**
             * グループ別ユーザー毎の権限押下時
             */
            onClickGroupUserAuthority: function (rowData, authority) {
                console.log("onClickGroupUserAuthority", rowData, authority)
                if (rowData.authorities == null) {
                    rowData.authorities = []
                    return
                }
                const index = rowData.authorities.findIndex((v)=>v == authority)
                if (index < 0) {
                    rowData.authorities.push(authority)
                } else {
                    rowData.authorities.splice(index, 1)
                }
                console.log(rowData.authorities)
            },
            /**
             * "このユーザーの設定を他の全員にコピー" 選択時
             */
            onSelectedCopyGroupUserSetting: function (rowData) {
                this.usersAuthorityList.forEach(function(userData) {
                    userData.authorities = rowData.authorities.concat()
                })
            },
            onImportedImage: function (image) {
                this.editImage.image = image
                this.editImage.state = 1
                this.editImage.capturedDate = this.df_currentDateTime()
            },
            onClickDeleteImage: function () {
                this.editImage.url = ""
                this.editImage.image = ""
                this.editImage.state = 2                    
            },
            onSelectedURL: function () {
                if (this.editItems.selectedStreamingURL.isNewData == true) {
                    this.editItems.streamingURL = ""
                    this.editItems.streamingType = 1
                } else {
                    this.editItems.streamingURL = this.editItems.selectedStreamingURL.url
                    this.editItems.streamingType = this.editItems.selectedStreamingURL.type
                }
            },
            onClickAddStreamingURL: function () {
                const url = {
                    isNewData: false,
                    type: this.editItems.streamingType,
                    url: this.editItems.streamingURL
                }
                this.editItems.streamingURLs.push(url)
                this.editItems.selectedStreamingURL = url
            },
            onClickChangeStreamingURL: function () {
                this.editItems.selectedStreamingURL.url = this.editItems.streamingURL
            },
            onClickDeleteStreamingURL: function () {
                const index = this.editItems.streamingURLs.findIndex((v)=>v == this.editItems.selectedStreamingURL)
                console.log(index)
                this.editItems.streamingURLs.splice(index, 1)
                this.editItems.streamingURL = ""
                this.editItems.selectedStreamingURL = this.editItems.streamingURLs[0]
            },
            onClickSave: function () {
                
                if (!this.$refs.form.validate()) {
                    console.log("input error!!")
                    return
                }

                if (this.editItems.group == undefined) {
                    this.editItems.group = null
                }

                if (this.editItems.address.areaID == undefined) {
                    this.editItems.address.areaID = null
                }
                
                console.log("MaintenancePlace", "onClickSave", this.editItems)

                if (this.editItems.details.variety == null) {
                    this.$refs.confirm.show({
                        title: "品種の選択",
                        message: "この圃場で栽培する品種を選択して下さい。",
                        buttonYes: "戻る",
                        buttonNo: "",
                        width: 600,
                    })
                    return
                }

                const self = this
                const userUID = this.$store.getters["userUID"]

                this.$refs.confirm.show({
                    title: "登録",
                    message: "圃場を登録しますか？",
                    buttonYes: "登録する",
                    buttonNo: "いいえ",
                    width: 400,
                    listenerYes: function () {
                        self.updatePlace()
                        return true
                    },
                })
            },
            /**
             * 農薬管理の回数起点(月)選択時
             */
            onChangedAgrichemicalStartMonth: function () {
                this.refreshAgrichemicalDays(this.editItems.managementAgrichemical.startDate.month)
                const lastDay = this.getLastDayOf(this.editItems.managementAgrichemical.startDate.month)
                if (this.editItems.managementAgrichemical.startDate.day > lastDay) {
                    this.editItems.managementAgrichemical.startDate.day = lastDay
                }
            },
            /**
             * 指定された月で、農薬管理の起点の日リストの内容を更新
             */
            refreshAgrichemicalDays: function (month) {
                this.agrichemicalStartDateDays = []
                for (var day=1; day<=this.getLastDayOf(month); day++) {
                    this.agrichemicalStartDateDays.push(day)
                }
            },
            /**
             * 指定された月の最後の日を返す(農薬管理の起点の日を設定する為の処理なので、年は考慮していない(2月は28日までとして閏年は無視)
             */
            getLastDayOf: function (month) {
                const lastDays = [31,28,31,30,31,30,31,31,30,31,30,31]
                return lastDays[month-1]
            },
            /**
             * 場所の更新処理
             */
            updatePlace: function () {
                const self = this
                const userUID = this.$store.getters["userUID"]

                // 新しい栽培区分が指定されている時は、保存する栽培区分を作成
                var newCultivationType = null

                if (self.editItems.cultivationType == null && self.editItems.cultivationTypeName != null && self.editItems.cultivationTypeName.length > 0) {
                    var type = 1
                    if (self.cultivationTypes.length >= 1) {
                        type = Math.max(...self.cultivationTypes.map(m => m.type)) + 1
                    }
                    if (type <= 100) {
                        type = 101
                    }
                    newCultivationType = {
                        type: type,
                        name: self.editItems.cultivationTypeName,
                        register: {
                            dateTime: self.df_currentDateTime(),
                            userUID: userUID
                        },
                        version: "1.0.0"
                    }
                    self.editItems.cultivationType = type
                    console.log("new cultivation type", newCultivationType)
                }

                // 保存する場所の作成
                var place = self.targetPlace

                if (place == null) {
                    var id = 1
                    if (self.places.length >= 1) {
                        id = Math.max(...self.places.map(m => m.body.placeID)) + 1
                    }
                    place = {
                        version: "1.0.0",
                        placeID: id,
                        isDeleted: false,
                        register: {
                            userUID: userUID,
                            dateTime: self.df_currentDateTime()
                        },
                        updater: {
                            userUID: "",
                            dateTime: ""
                        },
                    }
                } else {
                    place.updater.userUID = userUID,
                    place.updater.dateTime = self.df_currentDateTime()
                }

                place.name = self.editItems.name
                place.placeGroupID = self.editItems.group
                place.address = {
                    postalCode: self.editItems.address.postalCode,
                    pref:self.editItems.address.pref,
                    city:self.editItems.address.city,
                    address1:self.editItems.address.address1,
                    address2:self.editItems.address.address2,
                    areaID: self.editItems.address.areaID
                }
                
                place.cultivationType = self.editItems.cultivationType
                place.details = {
                    area: self.editItems.details.area * 1,
                    variety: {
                        cropID: self.editItems.details.variety.cropID,
                        varietyID: self.editItems.details.variety.varietyID,
                    }
                }
                place.memo = self.editItems.memo

                place.streamingURLs = []
                if (self.editItems.streamingURLs.length > 1) {
                    self.editItems.streamingURLs.forEach(function(url){
                        if (url.isNewData == false) {
                            place.streamingURLs.push(
                                {
                                    url: url.url,
                                    type: url.type
                                }
                            )
                        }
                    })
                }

                place.groupUserAuthorities = []
                for (var i=0; i<this.editItems.groupUserAuthorities.length; i++) {
                    if (this.editItems.groupUserAuthorities[i].enable) {
                        place.groupUserAuthorities.push(this.editItems.groupUserAuthorities[i].authority.key)
                    }
                }

                if (this.editItems.managementAgrichemical.enabled) {                    
                    var dateTime = place.managementAgrichemical == null || place.managementAgrichemical.dateTime == "" ? this.df_currentDateTime() : place.managementAgrichemical.dateTime
                    place.managementAgrichemical = {
                        enabled: this.editItems.managementAgrichemical.enabled,
                        target: this.editItems.managementAgrichemical.target,
                        dateTime: dateTime,
                        startDate: {
                            month: this.editItems.managementAgrichemical.startDate.month,
                            day: this.editItems.managementAgrichemical.startDate.day
                        }
                    }
                } else {
                    if (self.targetPlace == null) {
                        place.managementAgrichemical = {
                            enabled: false,
                            target: null,
                            dateTime: "",
                            startDate: {
                                month: 1,
                                day: 1
                            }
                        }
                    } else {
                        place.managementAgrichemical.enabled = false
                    }
                }

                console.log(place)

                // 権限保存処理を行うファンクション
                const userAuthoritieRegister = function () {
                    const records = []
                    for (var rowData of self.usersAuthorityList) {
                        var targetRecord = records.find((v)=>v.ownerUserUID == rowData.group.ownerUserUID && v.groupNo == rowData.group.groupNo)
                        if (targetRecord == null) {
                            targetRecord = {
                                placeID: place.placeID,
                                ownerUserUID: rowData.group.ownerUserUID,
                                groupNo: rowData.group.groupNo,
                                users: {}
                            }
                            records.push(targetRecord)
                        }
                        if (rowData.authorities == null || rowData.authorities.findIndex((v)=>v == "place") >= 0) {
                        } else {
                            targetRecord.users[rowData.user.userUID] = rowData.authorities
                        }
                    }

                    console.log("userAuthoritieRegister", records)

                    const batch = db.batch()
                    for (var record of records) {
                        const docRef = db.collection("users").doc(self.loggedInUserUID)
                        .collection("places").doc(record.placeID+"")
                        .collection("authorities").doc(record.ownerUserUID+"_"+record.groupNo)

                        if (Object.keys(record.users).length == 0) {
                            batch.delete(docRef)
                            console.log("delete", record)
                        } else {
                            batch.set(docRef, record)
                            console.log("add", record)
                        }
                    }

                    batch.commit().then(function(){
                        self.isView = false
                    }).catch (function (error) {
                        self.$store.commit("notification", {message:"権限の登録に失敗しました。", isError:true})
                        self.mi_writeLog("MaintenancePlace/updatePlace", "権限の登録に失敗しました。("+error+")")
                    })
                }

                // 場所と栽培区分の保存処理を行うファンクション
                const updater = function () {
                    console.log(place, self.targetPlace)
                    db.collection("users").doc(userUID).collection("places").doc(""+place.placeID).set(place).then(function() {
                        self.$store.commit("notification", {message:"場所を登録しました。", isError:false})
                        self.$emit("onUpdatedPlace", place)
                        userAuthoritieRegister()
                        // self.isView = false
                    }).catch (function (error) {
                        self.$store.commit("notification", {message:"場所の登録に失敗しました。", isError:true})
                    })

                    if (newCultivationType != null) {
                        db.collection("users").doc(userUID).collection("managements").doc("cultivation_type").collection("cultivation_types").doc(""+newCultivationType.type).set(newCultivationType).then(function() {
                            self.$store.commit("notification", {message:"新しい栽培区分を登録しました。", isError:false})
                            self.$emit("onAddNewCultivationType", newCultivationType)
                        }).catch (function (error) {
                            self.$store.commit("notification", {message:"新しい栽培区分の登録に失敗しました。", isError:true})
                        })
                    }
                }

                // アバターから処理
                const uploadUrl = "images/users/" + userUID + "/places/" + place.placeID + "/image"
                var storage = fb.storage().ref()
                var outputRef = storage.child(uploadUrl)

                console.log("editImage", self.editImage)
                switch (self.editImage.state) {
                    case 1: // 変更
                        // ===============================
                        // 画像のアップロード
                        const startIndex = self.editImage.image.indexOf(",") + 1
                        outputRef.putString(self.editImage.image.substring(startIndex), 'base64').then(function(snapShot){
                            snapShot.ref.getDownloadURL().then (function(url){
                                place.image = {
                                    version: "1.0.0",
                                    url: url,
                                    capturedDate: self.editImage.capturedDate
                                }
                                // =======================================
                                // 画像の処理が終了で、ユーザー情報更新
                                updater()
                            })
                        })
                        break;
                    case 2:
                        if (place.image != null) {
                            console.log("delete image start")
                            outputRef.delete().then(function (){
                                console.log("delete image completed")
                                place.image = null
                                updater()
                            })
                        }
                        break;
                    case 0:
                        updater()
                        break;
                }
            },
            /**
             * この画面を表示
             * @param targetPlace 編集対象の場所(null時は新規)
             */
            show: function (targetPlace) {
                const self = this
                
                this.editItems.streamingURLs = []
                this.editItems.streamingURLs.push(
                    {
                        isNewData: true,
                        type: 1,
                        url: "新しいURLを追加"
                    }
                )
                this.editItems.streamingURL = ""

                this.editItems.groupUserAuthorities = []
                
                if (targetPlace != null) {
                    this.targetPlace = targetPlace
                    this.editItems.name = targetPlace.name
                    this.editItems.group = null
                    if (targetPlace.placeGroupID != null) {
                        this.editItems.group = targetPlace.placeGroupID
                    }
                    if (targetPlace.address != null) {
                        this.editItems.address.postalCode = targetPlace.address.postalCode
                        this.editItems.address.pref = targetPlace.address.pref
                        this.editItems.address.city = targetPlace.address.city
                        this.editItems.address.address1 = targetPlace.address.address1
                        this.editItems.address.address2 = targetPlace.address.address2
                        this.editItems.address.areaID = targetPlace.address.areaID
                    }
                    if (targetPlace.cultivationType != null) {
                        this.editItems.cultivationType = targetPlace.cultivationType
                    }
                    if (targetPlace.details != null) {
                        this.editItems.details.area = targetPlace.details.area
                        this.editItems.details.variety = {
                            cropID: targetPlace.details.variety.cropID,
                            varietyID: targetPlace.details.variety.varietyID,
                        }
                    } else {
                        this.editItems.details.area = 0
                        this.editItems.details.variety = null
                    }
                    if (targetPlace.memo != null) {
                        this.editItems.memo = targetPlace.memo
                    } else {
                        this.editItems.memo = null
                    }
                    if (this.targetPlace.streamingURLs != null && this.targetPlace.streamingURLs.length > 0) {
                        this.targetPlace.streamingURLs.forEach(function(url){
                            self.editItems.streamingURLs.push(
                                {
                                    isNewData: false,
                                    type: url.type,
                                    url: url.url
                                }
                            )
                        })
                    }
                    for (var i=0; i<this.placeGroupUserAuthorities.length; i++) {
                        var enable = false
                        if (targetPlace.groupUserAuthorities.findIndex((v)=>v == this.placeGroupUserAuthorities[i].key) >= 0) {
                            enable = true
                        }
                        this.editItems.groupUserAuthorities.push(
                            {
                                authority: this.placeGroupUserAuthorities[i],
                                enable: enable
                            }
                        )
                    }

                    this.editItems.managementAgrichemical = {
                        enabled: targetPlace.managementAgrichemical.enabled,
                        target: targetPlace.managementAgrichemical.target,
                        dateTime: targetPlace.managementAgrichemical.dateTime,
                        startDate: {
                            month: targetPlace.managementAgrichemical.startDate.month,
                            day: targetPlace.managementAgrichemical.startDate.day
                        }
                    }
                    
                } else {
                    this.editItems.name = ""
                    this.editItems.group = null
                    this.editItems.streamingURLs = []
                    this.editItems.selectedStreamingURL = null
                    this.editItems.streamingURL = ""
                    this.editItems.streamingType = 1
                    this.editItems.address.postalCode = ""
                    this.editItems.address.pref = ""
                    this.editItems.address.city = ""
                    this.editItems.address.address1 = ""
                    this.editItems.address.address2 = ""
                    this.editItems.address.areaID = ""
                    this.editItems.cultivationType = null
                    this.editItems.cultivationTypeName = null
                    this.editItems.details.area = 0
                    this.editItems.details.variety = null
                    this.editItems.groupUserAuthorities = []
                    this.editItems.managementAgrichemical.enabled = false
                    this.editItems.managementAgrichemical.target = null
                    this.editItems.managementAgrichemical.startDate.month = 1
                    this.editItems.managementAgrichemical.startDate.day = 1
                    this.editItems.memo = null

                    /** 新しい場所の時は、権限を設定 */
                    for (var i=0; i<this.placeGroupUserAuthorities.length; i++) {
                        var enable = false
                        switch (this.placeGroupUserAuthorities[i]) {
                            case "browse":
                            case "work":
                            case "environment":
                                enable = true
                                break
                        }
                        this.editItems.groupUserAuthorities.push(
                            {
                                authority: this.placeGroupUserAuthorities[i],
                                enable: enable
                            }
                        )
                    }
                    // 農薬管理
                    this.editItems.managementAgrichemical = {
                        enabled: false,
                        target: null,
                        dateTime: "",
                        startDate: {
                            month: 1,
                            day: 1
                        }
                    }
                }
                console.log(targetPlace, this.editItems)

                if (targetPlace != null && targetPlace.image != null) {
                    this.editImage = {
                        url: targetPlace.image.url,
                        image: "",
                        capturedDate: targetPlace.image.capturedDate,
                        state: 0    // 0:未変更,1:変更,2:削除
                    }
                } else {
                    this.editImage = {
                        url: "",
                        image: "",
                        capturedDate: "",
                        state: 0    // 0:未変更,1:変更,2:削除
                    }
                }
                console.log(this.editImage)

                /** グループ別ユーザー別の権限リスト表示用 */
                this.usersAuthorityList = []

                const groupUserSetter = function (group, users) {
                    for (var user of users) {
                        if (user.body.userUID != self.loggedInUserUID) {
                            const row = {
                                group: group,
                                user: user.body,
                                userInfo: user.userInfo,
                                authorities: null
                            }
                            self.usersAuthorityList.push(row)
                        }
                    }
                }
                const groups = this.$store.getters["managementItems/groups"]
                for (var group of groups) {
                    groupUserSetter(group.body, group.users)
                }

                const belongGroups = this.$store.getters["managementItems/belongGroups"]
                for (var group of belongGroups) {
                    groupUserSetter(group.group, group.users)
                }

                if (targetPlace != null) {
                    db.collection("users").doc(self.loggedInUserUID)
                    .collection("places").doc(targetPlace.placeID+"")
                    .collection("authorities").get().then(function(snapShot){

                        for (var doc of snapShot.docs) {
                            const authorities = doc.data()
                            for (var userUID of Object.keys(authorities.users)) {
                                const targetUser = self.usersAuthorityList.find(
                                    (v)=>v.group.ownerUserUID == authorities.ownerUserUID && v.group.groupNo == authorities.groupNo && v.user.userUID == userUID
                                )
                                if (targetUser != null) {
                                    console.log(authorities.users[userUID])
                                    targetUser.authorities = authorities.users[userUID].concat()
                                }
                            }
                        }

                        self.sortUsersAuthorityList("group")

                    }).catch (function(error) {
                        console.log(error)
                        self.mi_writeLog("MaintenancePlace/show", "グループユーザー権限取得の処理に失敗しました。("+error+")")
                    })
                } else {
                    this.sortUsersAuthorityList("group")
                }

                this.isView = true
            },
            /**
             * 指定された順序でユーザー毎の権限を並び替え
             */
            sortUsersAuthorityList: function (order) {
                const self = this
                switch (order) {
                    case "group":
                        this.usersAuthorityList.sort(function(x, y) {
                            if (x.group.ownerUserUID > y.group.ownerUserUID) {
                                return 1
                            }
                            if (x.group.ownerUserUID < y.group.ownerUserUID) {
                                return -1
                            }
                            if (x.group.groupNo > y.group.groupNo) {
                                return 1
                            }
                            if (x.group.groupNo < y.group.groupNo) {
                                return -1
                            }
                            if (x.userInfo.userName > y.userInfo.userName) {
                                return 1
                            }
                            if (x.userInfo.userName < y.userInfo.userName) {
                                return -1
                            }
                            return 0
                        })
                        break;
                    case "user":
                        this.usersAuthorityList.sort(function(x, y) {
                            if (x.userInfo.userName > y.userInfo.userName) {
                                return 1
                            }
                            if (x.userInfo.userName < y.userInfo.userName) {
                                return -1
                            }
                            if (x.group.ownerUserUID > y.group.ownerUserUID) {
                                return 1
                            }
                            if (x.group.ownerUserUID < y.group.ownerUserUID) {
                                return -1
                            }
                            if (x.group.groupNo > y.group.groupNo) {
                                return 1
                            }
                            if (x.group.groupNo < y.group.groupNo) {
                                return -1
                            }
                            return 0
                        })
                        break;
                }
                this.usersAuthorityListOrder = order
            }
        }
    }
</script>
